import {getStorageSnapshot} from './auth';

export type ProfileKind = 'admin' | 'monitor' | 'fleet' | 'client';

export const getCurrentProfile = (): ProfileKind | undefined => {
  return getStorageSnapshot().auth.profile;
};

export const isCurrentProfileAdmin = () => {
  return getCurrentProfile() === 'admin';
};

export const isCurrentProfileMonitor = () => {
  return getCurrentProfile() === 'monitor';
};
